import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import * as styles from './transcript.module.scss';

import vector from './images/vector.svg';

export const TranscriptBlock = ({ title = 'Transcript of the webinar', children, isVisible = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpenTranscriptDescription = () => {
    setIsOpen((prevState) => !prevState);
  };

  useEffect(() => {
    if (isOpen !== isVisible) setIsOpen(isVisible);
  }, []);

  return (
    <div
      className={`gatsby-fullsize ${isOpen && styles.transcriptBlockContainerVisible} ${
        styles.transcriptBlockContainer
      }`}
    >
      <div className={`gatsby-fullsize ${styles.transcriptTopLabel}`}>
        <button
          className={styles.visibilityToggleButton}
          onClick={toggleOpenTranscriptDescription}
          data-tip={`Click to ${isOpen ? 'hide' : 'show'} transcript`}
        >
          <ReactTooltip wrapper="span" />
          <img loading="lazy" className={styles.descriptionControlImage} src={vector} alt="expand" />
        </button>
        <h2 className={styles.transcriptTitle}>{title}</h2>
      </div>
      <div
        className={`gatsby-fullsize ${styles.transcriptDescription}`}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    </div>
  );
};

TranscriptBlock.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element.isRequired]),
  label: PropTypes.string,
};
